import { render, staticRenderFns } from "./DashboardMenuBranch.vue?vue&type=template&id=6fc7e291&scoped=true"
import script from "./DashboardMenuBranch.vue?vue&type=script&lang=js"
export * from "./DashboardMenuBranch.vue?vue&type=script&lang=js"
import style0 from "./DashboardMenuBranch.vue?vue&type=style&index=0&id=6fc7e291&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc7e291",
  null
  
)

export default component.exports